'use client';

import Link from 'next/link';
import Image from 'next/image';
import FooterNewsletterWrapper from './FooterNewsletterWrapper';

// Using existing logo from public folder
const imgVibeMake = "/logo-vibemake.svg";
// Social icons - using the existing ones from all-assets
const imgInstagram = "/social-instagram.svg";
const imgX = "/social-x.svg";
const imgLinkedIn = "/social-linkedin.svg";
const imgFacebook = "/social-facebook.svg";

export default function Footer() {
  return (
    <footer className="w-full flex justify-center">
      <div className="w-full max-w-[1440px] bg-[#000000] relative">
          {/* Upper Footer Section */}
          <div className="flex flex-col md:flex-row items-start justify-between px-6 sm:px-8 md:px-10 lg:px-12 pt-12 sm:pt-16 md:pt-[50px] lg:pt-[60px] pb-8 sm:pb-9 lg:pb-10">
          {/* Left side - Logo and Powered by */}
          <div className="flex flex-col h-auto md:h-[52px] items-start justify-between gap-4 md:gap-0">
            {/* Logo */}
            <div className="h-[20.86px] relative shrink-0 w-[164.624px]">
              <Image 
                alt="Vibe & Make" 
                src={imgVibeMake}
                width={165}
                height={21}
                className="block max-w-none"
                loading="lazy"
              />
            </div>
            
            {/* Powered by */}
            <div className="w-[167px]">
              <div className="font-ibm-plex-sans-condensed text-[#ffffff] text-[14px] text-left tracking-[1.4px] uppercase">
                <p className="leading-[20px]">
                  <span>POWERED BY </span>
                  <Link href="https://maker.co" className="underline hover:opacity-80 transition-opacity">
                    MAKER
                  </Link>
                </p>
              </div>
            </div>
          </div>

          {/* Right side - Newsletter signup */}
          <div className="flex flex-col gap-4 items-start justify-start mt-8 md:mt-0">
            <div className="font-ibm-plex-sans text-[#ffffff] text-[16px] sm:text-[18px] text-left leading-[24px]">
              <p>Get the latest in AI: subscribe to our newsletter.</p>
            </div>
            <FooterNewsletterWrapper
              source="footer"
              variant="dark"
              size="medium"
              showLabel={false}
              placeholder="E-MAIL ADDRESS"
              buttonText="SUBSCRIBE"
              className="w-full md:w-auto"
            />
          </div>
          </div>

          {/* Divider Line */}
          <div className="px-6 sm:px-8 md:px-10 lg:px-12">
            <div className="h-px bg-white opacity-20 w-full"></div>
          </div>

          {/* Lower Footer Section */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between px-6 sm:px-8 md:px-10 lg:px-12 py-8 sm:py-9 md:py-9 lg:py-10 gap-6 sm:gap-0">
          {/* Left side - Legal links */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-7 items-start font-ibm-plex-sans-condensed text-[#ffffff] text-[14px] text-left tracking-[1.4px] uppercase">
            {/* Temporarily disabled until pages are created
            <Link href="/cookies" className="hover:opacity-70 transition-opacity">
              <p className="leading-[20px] whitespace-nowrap">COOKIES</p>
            </Link>
            <Link href="/privacy-terms" className="hover:opacity-70 transition-opacity">
              <p className="leading-[20px] whitespace-nowrap">PRIVACY & TERMS</p>
            </Link>
            <Link href="/about" className="hover:opacity-70 transition-opacity">
              <p className="leading-[20px] whitespace-nowrap">ABOUT US</p>
            </Link>
            */}
            <p className="leading-[20px] text-white/50">© 2025 Vibe&Make. All rights reserved.</p>
          </div>

          {/* Right side - Social media icons */}
          <div className="flex flex-row gap-6 items-center">
            <a 
              href="https://instagram.com/vibemake" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:opacity-70 transition-opacity"
              aria-label="Instagram"
            >
              <Image
                alt="Instagram"
                src={imgInstagram}
                width={19}
                height={19}
                className="block"
                loading="lazy"
              />
            </a>
            <a 
              href="https://x.com/vibemake" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:opacity-70 transition-opacity"
              aria-label="X (Twitter)"
            >
              <Image
                alt="X (Twitter)"
                src={imgX}
                width={19}
                height={19}
                className="block"
                loading="lazy"
              />
            </a>
            <a 
              href="https://linkedin.com/company/vibemake" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:opacity-70 transition-opacity"
              aria-label="LinkedIn"
            >
              <Image
                alt="LinkedIn"
                src={imgLinkedIn}
                width={19}
                height={19}
                className="block"
                loading="lazy"
              />
            </a>
            <a 
              href="https://facebook.com/company/vibemake" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:opacity-70 transition-opacity"
              aria-label="Facebook"
            >
              <Image
                alt="Facebook"
                src={imgFacebook}
                width={19}
                height={19}
                className="block"
                loading="lazy"
              />
            </a>
          </div>
          </div>
      </div>
    </footer>
  );
}